module.exports = __webpack_public_path__ + "static/media/hirz.7879e085.webp";